import type { PublicNavContext } from "../publicNavigation";
import type { NavConfig, NavItem } from "./types";

export function getResourcesNavConfig(
  ctx: PublicNavContext,
): NavConfig["resources"] {
  const { isSwedish } = ctx;
  const items: NavItem[] = [
    {
      label: isSwedish ? "Blogg" : "Blog",
      href: isSwedish ? "/resurser/blogg" : "/en/resources/blog",
      description: isSwedish
        ? "Artiklar, guider, jämförelser och nyheter"
        : "Articles, guides, comparisons and news",
    },
    {
      label: isSwedish ? "Hjälp" : "Help",
      href: isSwedish ? "/hjalp" : "/en/help",
      description: isSwedish ? "Så använder ni Caire" : "How to use Caire",
    },
    {
      label: isSwedish
        ? "Utvecklare & integrationer"
        : "Developers & integrations",
      href: isSwedish ? "/resurser/utvecklare" : "/en/resources/developers",
      description: isSwedish
        ? "Connect API, Swagger, MCP och arkitektur"
        : "Connect API, Swagger, MCP and architecture",
    },
    {
      label: isSwedish ? "Vanliga frågor" : "FAQ",
      href: isSwedish ? "/vanliga-fragor" : "/en/faq",
    },
    {
      label: isSwedish ? "Kalkylator" : "Calculator",
      href: isSwedish ? "/kalkylator" : "/en/calculator",
    },
  ];
  const blog = [
    {
      label: isSwedish ? "Artiklar" : "Articles",
      href: isSwedish ? "/resurser/artiklar" : "/en/resources/articles",
    },
    {
      label: isSwedish ? "Guider" : "Guides",
      href: isSwedish ? "/resurser/guider" : "/en/resources/guides",
    },
    {
      label: isSwedish ? "Jämförelser" : "Comparisons",
      href: isSwedish ? "/resurser/jamforelser" : "/en/resources/comparisons",
    },
    {
      label: isSwedish ? "Nyheter" : "News",
      href: isSwedish ? "/resurser/nyheter" : "/en/resources/news",
    },
  ];
  return {
    label: isSwedish ? "Resurser" : "Resources",
    overview: isSwedish ? "/resurser" : "/en/resources",
    submenu: {
      layout: "mega",
      overview: {
        label: isSwedish ? "Alla resurser" : "All resources",
        href: isSwedish ? "/resurser" : "/en/resources",
      },
      items,
      groups: [{ label: isSwedish ? "I bloggen" : "In the blog", items: blog }],
    },
    description: isSwedish
      ? "Kunskap, produkthjälp och utvecklarresurser"
      : "Knowledge, product help and developer resources",
    sections: {
      documentation: {
        label: isSwedish ? "Hjälp och utvecklare" : "Help and developers",
        href: isSwedish ? "/hjalp" : "/en/help",
        items: items.filter(
          (item) =>
            item.href.includes("help") ||
            item.href.includes("hjalp") ||
            item.href.includes("utvecklare") ||
            item.href.includes("developers"),
        ),
      },
      blog: {
        label: isSwedish ? "Blogg" : "Blog",
        href: items[0].href,
        items: blog,
      },
    },
  };
}
